"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const three_1 = require("three");
const TextGeometry_js_1 = require("three/examples/jsm/geometries/TextGeometry.js");
const types_1 = require("~/store/types");
const Leader_3d_1 = __importDefault(require("./Leader.3d"));
const consts_1 = require("../consts");
const CIRCLE_RADIUS = 0.75;
const UI_OFFSET = 0.05;
const BALLON_TARGET = new three_1.Vector3().copy(consts_1.consts.SCREENSHOT_CAMERA_DIRECTION).multiplyScalar(30);
const ballonTransparencyProps = {
    transparent: true,
    opacity: 1.0,
};
class BOMBallonLeader extends Leader_3d_1.default {
    constructor(viewer, lineMaterial, arrowMaterial, labelText, font) {
        // TODO: Fix polygon offset for line material
        super(viewer, lineMaterial, '');
        this.ballon = new three_1.Object3D();
        this.arrowMaterial = arrowMaterial;
        this.labelText = labelText;
        this.font = font;
        Object.defineProperty(this.ballon, 'type', { value: types_1.ITEM_TYPE.BOM_BALLON, writable: true });
        this.ballon.renderOrder = Infinity;
        this.viewer.getScene().add(this.ballon);
    }
    draw(startPoint, endPoint) {
        this.drawLine(startPoint, endPoint);
        this.drawLabelAtPosition(startPoint);
    }
    createLabel() {
        return document.createElement('div');
    }
    clear() {
        super.clear();
        this.ballon.clear();
    }
    drawLabelAtPosition(position) {
        this.createBallon(this.labelText);
        this.ballon.position.set(position.x, position.y, position.z);
        this.ballon.lookAt(BALLON_TARGET);
        this.ballon.rotateZ((2 * Math.PI) / 3 - 0.075);
    }
    createBallon(text) {
        const textMesh = this.createTextObject(text);
        const circleMesh = this.createCircleObject();
        this.ballon.add(textMesh, circleMesh);
    }
    createCircleObject() {
        const circleMaterial = new three_1.MeshBasicMaterial(Object.assign({ color: 0xffffff, side: three_1.DoubleSide }, ballonTransparencyProps));
        const circleGeometry = new three_1.CircleGeometry(CIRCLE_RADIUS, 32);
        const circleMesh = new three_1.Mesh(circleGeometry, circleMaterial);
        const lineMaterial = new three_1.LineBasicMaterial(Object.assign({ color: 0x000000 }, ballonTransparencyProps));
        const lineGeometry = new three_1.BufferGeometry().setFromPoints(new three_1.Path().absarc(0, 0, CIRCLE_RADIUS, 0, Math.PI * 2, true).getSpacedPoints(50));
        const borderLine = new three_1.Line(lineGeometry, lineMaterial);
        borderLine.translateZ(UI_OFFSET);
        const circleObject = new three_1.Object3D();
        circleObject.add(circleMesh, borderLine);
        return circleObject;
    }
    createTextObject(text) {
        const geometry = new TextGeometry_js_1.TextGeometry(text, {
            font: this.font,
            size: 0.65,
            height: 0.075,
            curveSegments: 12,
        });
        const material = [
            new three_1.MeshPhongMaterial(Object.assign({ color: 0x000000, flatShading: true }, ballonTransparencyProps)),
            new three_1.MeshPhongMaterial(Object.assign({ color: 0x000000, vertexColors: true }, ballonTransparencyProps)), // side
        ];
        const mesh = new three_1.Mesh(geometry, material);
        geometry.computeBoundingBox();
        geometry.computeVertexNormals();
        geometry.boundingBox.getCenter(mesh.position).multiplyScalar(-1);
        mesh.position.x = -geometry.boundingBox.max.x / 2;
        mesh.translateZ(UI_OFFSET);
        return mesh;
    }
    createLine(startPoint, endPoint) {
        const leaderDirection = endPoint.clone().sub(startPoint).normalize();
        const distance = startPoint.distanceTo(endPoint);
        const arrow = new three_1.ArrowHelper(leaderDirection.clone(), startPoint.clone(), distance, consts_1.consts.LEADER_COLOR, consts_1.consts.BOM_BALLOON_ARROW_HEAD_LENGTH, consts_1.consts.BOM_BALLOON_ARROW_HEAD_WIDTH);
        arrow.line.material = this.lineMaterial;
        arrow.cone.material = this.arrowMaterial;
        const group = new three_1.Group();
        group.add(arrow);
        return group;
    }
}
exports.default = BOMBallonLeader;
